import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useDynamicTags } from 'js/app/hooks/useDynamicTags';
import { setJumioStatus } from 'js/hooks/user/store/buzz/actions';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';
import { useIsUserVerified } from 'js/app/hooks/user/hooks/useIsUserVerified';

export const useSetUpdateUserDetailsStatus = () => {
    const dispatch = useDispatch();
    const isUserVerified = useIsUserVerified();
    const [dtagJumioUpdateInformationPopupHide] = useDynamicTags([DYNAMIC_TAG_NAMES.jumioUpdateInformationPopupHide]);

    return useCallback(() => {
        if (!isUserVerified && dtagJumioUpdateInformationPopupHide !== 'true') {
            dispatch(setJumioStatus('updateUserDetails'));
        }
    }, [dispatch, dtagJumioUpdateInformationPopupHide, isUserVerified]);
};
